import React from 'react';
import {IconProps} from './types';

export const IconGroups: React.FC<IconProps> = ({ 
    className, 
    width = 17, 
    height = 17, 
    fill = 'black' 
}) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={width} 
        height={height} 
        viewBox="0 0 17 17" 
        fill="none"
        className={className}
    >
        <path 
            d="M1.16667 9.83325H5.83333C5.83333 9.83325 6.5 9.83325 6.5 10.4999V15.1666C6.5 15.1666 6.5 15.8333 5.83333 15.8333H1.16667C1.16667 15.8333 0.5 15.8333 0.5 15.1666V10.4999C0.5 10.4999 0.5 9.83325 1.16667 9.83325Z" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M10.5 9.83325H15.1667C15.1667 9.83325 15.8334 9.83325 15.8334 10.4999V15.1666C15.8334 15.1666 15.8334 15.8333 15.1667 15.8333H10.5C10.5 15.8333 9.83337 15.8333 9.83337 15.1666V10.4999C9.83337 10.4999 9.83337 9.83325 10.5 9.83325Z" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M6.50004 0.5H11.1667C11.1667 0.5 11.8334 0.5 11.8334 1.16667V5.83333C11.8334 5.83333 11.8334 6.5 11.1667 6.5H6.50004C6.50004 6.5 5.83337 6.5 5.83337 5.83333V1.16667C5.83337 1.16667 5.83337 0.5 6.50004 0.5Z" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M13.8333 9.83398V8.50065C13.8333 8.32384 13.7631 8.15427 13.6381 8.02925C13.513 7.90422 13.3435 7.83398 13.1667 7.83398H3.16667C2.98986 7.83398 2.82029 7.90422 2.69526 8.02925C2.57024 8.15427 2.5 8.32384 2.5 8.50065V9.83398" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M9.16669 6.5V7.83333" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M7.16669 2.5H10.5" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M11.1667 11.8333H14.5" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
        <path 
            d="M1.83337 11.8333H5.16671" 
            stroke={fill} 
            strokeLinecap="round" 
            strokeLinejoin="round"
        />
    </svg>
);

export default IconGroups;

